import { getSolanaAccountSignatures } from '@pkg/solana'
import type {
  FetchSolanaAddressDataParameters,
  FetchSolanaAddressDataReturnTypes,
} from './types'

export const fetchSolanaAddressData = async ({
  rpcEndpoints,
  headers,
  account,
  startTime,
}: FetchSolanaAddressDataParameters): Promise<FetchSolanaAddressDataReturnTypes> => {
  const now = Date.now()
  const lastSyncedAt = account.lastSyncedAt?.getTime() ?? 0

  // 最終同期から 1 時間以内の場合は同期しない
  if (now - lastSyncedAt < 1000 * 60 * 60) {
    return undefined
  }

  const from = Math.max(
    lastSyncedAt - 300_000,
    startTime,
    new Date('2020-01-01').getTime(),
  )

  const { signatures, tokenAccountAddresses } =
    await getSolanaAccountSignatures({
      rpcEndpoints,
      accountAddress: account.solanaAddress,
      from,
      to: Date.now(),
      headers,
    })
  return {
    signatures,
    tokenAccountAddresses,
  }
}
